// import external dependencies
import 'custom-event-polyfill/polyfill.js'
import 'jquery';
import 'slick-carousel/slick/slick.js';
import 'is-in-viewport/src/index';
// import 'select2/dist/js/select2';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
// import aboutUs from './routes/about';


/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  // aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// // FontAwesome
import {
  config,
  library,
  dom,
} from '@fortawesome/fontawesome-svg-core';

// import the required icons
import {
} from '@fortawesome/free-solid-svg-icons';
import {
  faEnvelope,
} from '@fortawesome/free-regular-svg-icons';
import {
  faFacebookSquare,
  faTwitterSquare,
  faLinkedin,
  faLinkedinIn,
  faInstagram,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import {
  faUser,
} from '@fortawesome/pro-light-svg-icons';
import {
  faChevronLeft,
  faChevronRight,
  faSearch,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faTimesCircle,
} from '@fortawesome/pro-solid-svg-icons'; // fas

config.autoReplaceSvg = 'nest';


// add the imported icons to the library
library.add(
  faChevronLeft,
  faChevronRight,
  faEnvelope,
  faFacebookSquare,
  faTwitterSquare,
  faLinkedin,
  faLinkedinIn,
  faInstagram,
  faYoutube,
  faUser,
  faSearch,
  faTimesCircle
);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();



// WEBPACK FOOTER //
// ./scripts/main.js